import { isAxiosError } from 'axios';

export const isInvalidGrant = (error: unknown) => {
  if (isAxiosError(error)) {
    if (
      error.response?.data &&
      typeof error.response.data === 'object' &&
      'error' in error.response.data
    ) {
      return error.response.data.error === 'invalid_grant';
    }
  }
};
